import { useQuery, useMutation } from "@apollo/client";
import {
  GET_MY_WATCHLISTS,
  GET_WATCHLIST_WITH_PRICES,
  CREATE_WATCHLIST,
  ADD_WATCHLIST_ITEM,
  REMOVE_WATCHLIST_ITEM,
} from "../graphql/market-dashboard";

export const useWatchlist = () => {
  const { data, loading, error, refetch } = useQuery(GET_MY_WATCHLISTS);

  const [createWatchlist] = useMutation(CREATE_WATCHLIST, {
    refetchQueries: [{ query: GET_MY_WATCHLISTS }],
  });

  const [addItem] = useMutation(ADD_WATCHLIST_ITEM, {
    refetchQueries: [{ query: GET_MY_WATCHLISTS }],
  });

  const [removeItem] = useMutation(REMOVE_WATCHLIST_ITEM, {
    refetchQueries: [{ query: GET_MY_WATCHLISTS }],
  });

  return {
    watchlists: data?.myWatchlists || [],
    loading,
    error,
    createWatchlist,
    addItem,
    removeItem,
    refetch,
  };
};

export const useWatchlistWithPrices = (
  watchlistId: string,
  pollingInterval = 60000,
) => {
  const { data, loading, error } = useQuery(GET_WATCHLIST_WITH_PRICES, {
    variables: { watchlistId },
    pollInterval: pollingInterval,
    skip: !watchlistId,
  });

  return {
    watchlist: data?.watchlistWithPrices,
    loading,
    error,
  };
};
